<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-container class="pa-0 d-flex align-center mb-5 gap-8">
        <v-container class="wrapper-toggle d-flex pa-0 ma-0" style="width: 151px">
          <div
            v-for="(item, index) in activatorOptions"
            :key="index"
            @click="selectStatusPanel(item)"
            class="child flex-fill text-center"
            :style="{
              'background-color': selectedStatusPanel == item.value ? '#E5FEED' : '',
              'border-color': selectedStatusPanel == item.value ? '#0066ff' : 'silver',
              color: selectedStatusPanel == item.value ? '#137333' : '',
            }"
          >
            <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
          </div>
        </v-container>
        <div class="d-flex align-center">
          <v-checkbox v-model="syncUser" />
          <v-card-text
            class="pa-0 text-body-2"
            :style="{ color: !syncUser ? 'silver' : '' }"
          >
            {{ $t("Synchronize-persons-in-magnet") }}
          </v-card-text>
        </div>
      </v-container>
      <v-container class="pa-0 d-flex justify-space-between gap-3">
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="5" class="my-0 py-0 ps-0">
            <v-text-field
              v-model="magnetApiKey"
              :label="$t('apiKey')"
              :rules="[(v) => !!v || $t('is-required')]"
              outlined
              clearable
              dense
            />
          </v-col>
          <v-col cols="12" md="5" class="my-0 py-0">
            <autocomplete
              v-model="given"
              title="given"
              :rules="[(v) => !!v || $t('required')]"
              type="given"
            />
          </v-col>
          <v-col cols="12" md="2" class="my-0 py-0">
            <v-btn height="32" color="primary" class="mr-2" @click="create">
              {{ $t("submit") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="mt-3">
        <v-col cols="12">
          <v-chip
            v-if="hashkey"
            v-clipboard:copy="hashkey"
            label
            dark
            color="green"
            link
            @click="copied"
          >
            {{ $t("orderWebhook") }} : {{ hashkey }}
            <v-icon class="mx-2"> mdi-content-copy </v-icon>
          </v-chip>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import General from "../../../../Mixins/general";

export default {
  name: "Customer",
  mixins: [General],
  data: () => ({
    valid: true,
    render: false,
    magnetApiKey: null,
    hashkey: null,
    isLoading: false,
    selectedStatusPanel: null,
    given: null,
    snakbar: false,
    snakbarColor: null,
    snakbarText: null,
    syncUser: false,
  }),
  activated() {
    this.show();
  },
  computed: {
    activatorOptions() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
  },
  mounted() {
    this.show();
    this.selectedStatusPanel = "active";
  },
  methods: {
    selectStatusPanel(item) {
      this.selectedStatusPanel = item.value;
    },
    create() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$apipoint + "config/customer-club/magnet/store-config", {
          api_key: this.magnetApiKey,
          panel_status: this.selectedStatusPanel,
          given_id: this.given.id,
          sync_users: this.syncUser ? "active" : "deactive",
        })
        .then((r) => {
          if (r.data) {
            app.snakbarText = r.data.message;
            app.snakbarColor = "green";
            app.snakbar = true;

            if (r.data.data.panel_token) {
              this.hashkey =
                "https://integrator.abriron.com/api/customer-club/magnet/webhook?token=" +
                r.data.data.panel_token;
            }
          }
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$apipoint + "config/customer-club/magnet/get-config")
        .then((r) => {
          app.$nextTick(() => {
            if (r.data) {
              app.render = true;
              app.hashkey =
                "https://integrator.abriron.com/api/customer-club/magnet/webhook?token=" +
                r.data.magnet_config.panel_token;
              app.magnetApiKey = r.data.magnet_config.api_key;
              app.given = r.data.given_config;
              app.selectedStatusPanel = r.data.magnet_config.status;
              app.syncUser = app.resolveUserSync(r.data.magnet_config.sync_users);
            }
          });
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    resolveUserSync(value) {
      if (value == "active") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.v-card__text {
  width: auto !important;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
</style>
